import { produce } from "immer";
import {
  FETCH_AI_WALLETS,
  FETCH_AI_WALLETS_SUCCESS,
  FETCH_AI_WALLETS_FAILURE,
  //
  FETCH_AI_LEDGER,
  FETCH_AI_LEDGER_SUCCESS,
  FETCH_AI_LEDGER_FAILURE,
} from "./constants";

export const initialState = {
  isFetchingWallets: false,
  wallets: [],
  locationId: null,
  isFetchingLedger: false,
  isFetchingLedgerMore: false,
  ledger: [],
  ledgerMeta: {},
};

const AICreditsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_AI_WALLETS:
        draft.isFetchingWallets = true;
        break;
      case FETCH_AI_WALLETS_SUCCESS:
        draft.isFetchingWallets = false;
        draft.wallets = action.payload?.wallets ?? [];
        draft.locationId = action.payload?.location_id ?? null;
        break;
      case FETCH_AI_WALLETS_FAILURE:
        draft.isFetchingWallets = false;
        draft.wallets = [];
        break;

      case FETCH_AI_LEDGER:
        if (action.append) draft.isFetchingLedgerMore = true;
        else draft.isFetchingLedger = true;
        break;
      case FETCH_AI_LEDGER_SUCCESS: {
        draft.isFetchingLedger = false;
        draft.isFetchingLedgerMore = false;
        const rows = action.payload?.data ?? [];
        // Append on load-more (page > 1); replace on a fresh first page.
        draft.ledger = action.append ? [...draft.ledger, ...rows] : rows;
        draft.ledgerMeta = action.payload?.meta ?? {};
        break;
      }
      case FETCH_AI_LEDGER_FAILURE:
        draft.isFetchingLedger = false;
        draft.isFetchingLedgerMore = false;
        // Keep what's already loaded on a failed load-more.
        if (!action.append) {
          draft.ledger = [];
          draft.ledgerMeta = {};
        }
        break;

      default:
        return state;
    }
  });

export default AICreditsReducer;
